<template>
<div class="ti" style="margin-left: 10px;">
  <div style="margin-left: 10px;">
    <el-button size="mini" type="primary text2" style="margin-left: 10px;margin-top: 10px;"  @click="modals" v-if="ERP.isPermission(4002001001)">添加</el-button>
    <el-button size="mini" type="primary text2" @click="searchs">搜索</el-button>
    <div>
      <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}">
        <el-descriptions-item  label="费用收入类型">
          <el-select v-model="ChargeItemInTypeID" size="mini" multiple filterable collapse-tags style="width: 100%;" placeholder="费用收入类型">
            <el-option v-for="item in list2" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="费用类别">
          <el-select v-model="ChargeItemClassID" size="mini" multiple filterable collapse-tags style="width: 100%;" placeholder="费用类别">
              <el-option  v-for="item in list1"  :key="item.id" :label="item.name"  :value="item.id"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="费用类型">
          <el-select v-model="ChargeItemTypeID" size="mini" multiple filterable collapse-tags style="width: 100%;" placeholder="费用类型">
            <el-option v-for="item in list" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="请输入搜索名称">
          <el-input size="mini" placeholder="请输入搜索名称" v-model="search" clearable></el-input>
        </el-descriptions-item>
      </el-descriptions>
    </div>
  </div>
  <!-- 369369 -->
    <div style="margin-left: 10px;margin-top:10px">
      <el-table ref="multipleTable" :data="desserts" border tooltip-effect="dark" style="width: 100%" height="56vh">
        <el-table-column prop="sort" label="序号" width="80"></el-table-column>
        <el-table-column prop="ChargeItemInTypeID_name" label="费用收入类型" width="120"></el-table-column>
        <el-table-column prop="ChargeItemClassID_name" label="费用类别" width="120"></el-table-column>
        <el-table-column prop="ChargeItemTypeID_name" label="费用类型" width="120"></el-table-column>
        <el-table-column prop="chargeItem_name" label="费用分类名称" width="180"></el-table-column>
        <el-table-column prop="GoodsTaxNo" label="税目分类编码" show-overflow-tooltip></el-table-column>
        <el-table-column prop="GoodsTaxName" label="税目分类编码名称" width="120"></el-table-column>
        <el-table-column prop="taxRate" label="税率" width="120"></el-table-column>
        <el-table-column prop="date" label="日期" width="180"></el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <span class="cdj_td">
              <div style="color: #1867c0;cursor: pointer;" @click="xiugai(scope.row)" v-if="ERP.isPermission(4002001003)">修改</div>
              <div  style="color: red;margin-left: 5px;cursor: pointer;" @click="del( scope.row.id )" v-if="ERP.isPermission(4002001004)">删除</div>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pages" v-if="desserts">
      <Page :total="total" :page-size="page" @on-change="change"  show-total />
    </div>
    <div class="zhanwu" v-else>没有数据</div>
    <Modal
        v-model="modal1"
        :ok-text="anxiu"
        width="600"
        title="编辑"
        @on-ok="ok">
        <div>
          <el-form  style="height: 600px;overflow: auto;">
            <div class="cdj_margin_span">
              <span><span class="cdj_span">*</span>分类名称</span>
              <el-input class="cdj_input"  placeholder="分类名称" v-model="dades.chargeItem_name"></el-input>
            </div>
            <div class="cdj_margin_span">
              <span>费用收入类型</span>
              <el-select v-model="dades.ChargeItemInTypeID" filterable placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in list2"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="cdj_margin_span">
              <span>费用类别</span>
              <el-select v-model="dades.ChargeItemClassID" filterable placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in list1"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="cdj_margin_span">
              <span><span class="cdj_span">*</span>费用类型</span>
              <el-select v-model="dades.ChargeItemTypeID" filterable placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in list"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="cdj_margin_span">
              <span>税目分类编码</span>
              <el-input class="cdj_input"  placeholder="税目分类编码" v-model="dades.GoodsTaxNo"></el-input>
            </div>
            <div class="cdj_margin_span">
              <span>税目分类编码名称</span>
              <el-input class="cdj_input"  placeholder="税目分类编码名称" v-model="dades.GoodsTaxName"></el-input>
            </div>
            <div class="cdj_margin_span">
              <span>税率</span>
              <el-input class="cdj_input"  placeholder="税率" v-model="dades.taxRate"></el-input>
            </div>
          </el-form>
        </div>
    </Modal>
</div>

</template>

<script>
export default {
  name: 'pindexType',
  data () {
    return {
      ChargeItemTypeID:'',
      ChargeItemClassID:'',
      ChargeItemInTypeID:'',
      dades: {
        id:'',
        chargeItem_name:'',
        ChargeItemTypeID:'',
        ChargeItemClassID:'',
        ChargeItemInTypeID:'',
        GoodsTaxNo:'',
        GoodsTaxName:'',
        taxRate:'',
      },
      pages:'',
      value: '',
      value1:'',
      input1: '',
      desserts: '',
      cs:'',
      total:0,
      page:12,
      search:'',
      anxiu:'保存',
      modal1: false,
      loading:false,
      list:[
        {
          id:1,
          name:"常规收费项目"
        },
        {
          id:2,
          name:"抄表收费项目"
        },
        {
          id:3,
          name:"临时收费项目"
        },
        {
          id:4,
          name:"租赁收费项目"
        },
        {
          id:5,
          name:"分摊收费项目"
        },
        {
          id:6,
          name:"押金收费项目"
        },
        {
          id:11,
          name:"出入证收费项目"
        },
        {
          id:15,
          name:"常规实收类型"
        },
        {
          id:16,
          name:"临时实收类型"
        },
        {
          id:17,
          name:"停车实收类型"
        },
        {
          id:18,
          name:"卫星收视实收类型"
        }
      ],
      list1:[
        {
          id:1,
          name:"管理费收入"
        },
        {
          id:2,
          name:"车位收入"
        },
        {
          id:3,
          name:"其他业务收入"
        },
        {
          id:4,
          name:"代收代支"
        },

      ],
      list2:[
        {
          id:1,
          name:"营业收入"
        },
        {
          id:2,
          name:"非营业收入"
        }
      ],
    }
  },
  //界面没出来前加载
  created() {
  },
  // 加载数据
  mounted(){
    this.change(1);
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    //保存
    ok(){
      if(this.dades.chargeItem_name == ''){
        this.$Message.error('分类名称不能为空!');
        return false;
      }
      if(this.dades.ChargeItemTypeID == '' || this.dades.ChargeItemTypeID == null){
        this.$Message.error('费用类型不能为空!');
        return false;
      }
      this.$myhttp.post('admin/dynamicAdd',this.dades,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data[0] == 1){
            this.change(this.pages);
            this.$Message.success(backdata.data[1]);
          }else{
            this.$Message.error('编辑失败!');
          }
      });
    },
    //弹窗添加
    modals(){
      this.anxiu = "保存";
      if(this.dades.id){
        this.dades={
          id:'',
          chargeItem_name:'',
        };
      }
      this.modal1 = true;
    },
    //获得当前多少页,分页
    change(e){
      this.pages = e;
      ERP.showLoading()
      this.$Loading.start();
      let type = "&ChargeItemTypeID="+this.ChargeItemTypeID+"&ChargeItemClassID="+this.ChargeItemClassID+"&ChargeItemInTypeID="+this.ChargeItemInTypeID;
      this.$myhttp.get('admin/dynamic?page='+ e + '&search='+ this.search+type,{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
          this.desserts = backdata.data[0];
          this.total = backdata.data[1];
          this.page = backdata.data[2];
          this.$Loading.finish();
        ERP.hideLoading()
      });
    },
    //搜索
    searchs(){
      this.change(1);
    },
    //修改
    xiugai(item){
      this.dades.id = item.id;
      this.dades.chargeItem_name = item.chargeItem_name;
      this.dades.ChargeItemTypeID = item.ChargeItemTypeID =='--' ? '' : item.ChargeItemTypeID;
      this.dades.ChargeItemClassID = item.ChargeItemClassID =='--' ? '' : item.ChargeItemClassID;
      this.dades.ChargeItemInTypeID = item.ChargeItemInTypeID =='--' ? '' : item.ChargeItemInTypeID;
      this.dades.GoodsTaxNo = item.GoodsTaxNo =='--' ? '' : item.GoodsTaxNo;
      this.dades.GoodsTaxName = item.GoodsTaxName =='--' ? '' : item.GoodsTaxName;
      this.dades.taxRate = item.taxRate =='--' ? '' : item.taxRate;
      this.modal1 = true;
    },
    //删除
    del(e){
      this.$confirm('此操作将永久删除该权限吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading=true;
          this.$myhttp.post('admin/dynamicDelete',{id:e},{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              if(backdata.data == 200){
                this.dela = true;
                this.change(this.pages);
                this.$Message.success('删除成功!');
                this.loading=false;
              }
          });
        }).catch(() => {

        });
    },
  },

}
</script>
<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.color{
  color: #4091FF;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/Type.vue